import { Col, Image, Row } from 'antd'
import moment from 'moment'
import './GeneralInformation.style.less'
import { isEmptyValue, toJson } from '@/utils/common'
import { isArray, orderBy, startCase } from 'lodash'
import { formatDeliveryDate } from '@/utils/date'
import { Logger } from '@azure/msal-browser'

interface Props {
  data: any
  dataSetting: any
}

function GeneralInformation(props: Props) {
  const data = props.data?.generalInformation

  const location = toJson(
    props?.data?.inspection?.property_values?.find(
      (item: any) => item?.field === 'location'
    )?.value
  )

  const get_location_date = props?.data?.inspection.property_values?.find(
    (item: any) => item?.field === 'get_location_date'
  )?.value

  const customFieldName = (data: any) => {
    const field_names = !isEmptyValue(props.dataSetting)
      ? props.dataSetting[0]?.value?.field_names
      : []
    return (
      field_names?.find((item) => item?.field === data?.field)?.display_name ??
      startCase(data?.name)
    )
  }

  const leftFields = [
    {
      name: 'Inspection Date',
      field: 'inspectionDate',
      value: moment(data.inspectionDate).format('DD MMM YYYY'),
    },
    {
      name: 'Buyer',
      field: 'buyer',
      value: data?.buyer,
    },
    {
      name: 'Inspection Type',
      field: 'inspectionType',
      value: data?.inspectionType,
    },
    { name: 'Order No', field: 'number', value: data?.orderNumber },
    {
      name: 'Inspection No',
      field: 'inspectionNumber',
      value: data?.inspectionNumber,
    },
    {
      name: 'Style ID',
      field: 'styleId',
      value: data?.styleID,
    },
    {
      name: 'Inspector Name',
      field: 'inspectorName',
      value: data?.inspectorName,
    },
    {
      name: 'Product Category',
      field: 'productCategory',
      value: data?.productCategory,
    },
    {
      name: 'Inspection AQL',
      field: 'inspectionAQL',
      value: data?.inspectionAQL,
    },
    {
      name: 'Delivery Date',
      field: 'deliveryDate',
      value: formatDeliveryDate(data.deliveryDate),
    },
    {
      name: 'Order Quantity',
      field: 'orderQuantity',
      value: data?.orderQuantity,
    },
    ...(props.data?.inspection?.option?.partial_inspection?.status
      ? [
          {
            name: 'Inspection Quantity',
            field: 'inspectionQty',
            value: data?.inspectionQty,
          },
        ]
      : []),
    {
      name: 'Supplier',
      field: 'supplier',
      value: data?.supplier,
    },
    {
      name: 'Available Quantity',
      field: 'availableQty',
      value: data?.availableQty,
    },
    {
      name: 'Factory',
      field: 'factory',
      value: data?.factory,
    },
    {
      name: 'Sample Size',
      field: 'sampleSize',
      value: data?.sampleSize,
    },
    {
      name: 'Production Country',
      field: 'country',
      value: data?.productionCountry,
    },
  ]

  const orderImage = () => {
    if (!isEmptyValue(props.data?.order))
      return props.data?.order?.picture?.url_path
    return props.data?.orders[0]?.picture?.url_path
  }
  const supplierCode = () => {
    if (!isEmptyValue(props.data?.order))
      return props.data?.order?.supplier?.code
    return props.data?.orders[0]?.supplier?.code
  }

  const factoryCode = () => {
    if (!isEmptyValue(props.data?.order))
      return props.data?.order?.factory?.code
    return props.data?.orders[0]?.factory?.code
  }

  const dataCustoms = orderBy(
    props.data?.generalInformationCustom,
    'display_order',
    'desc'
  )?.map((item) => {
    return {
      name: item?.key,
      field: item?.key,
      value:
        item?.key == 'supplierCode'
          ? supplierCode()
          : item?.key == 'factoryCode'
          ? factoryCode()
          : isArray(item?.value)
          ? item?.value
              ?.map((tmp) => {
                return tmp
              })
              .join(', ')
          : item?.data_type == 'date'
          ? formatDeliveryDate(item.value)
          : item.value,
    }
  })

  return (
    <div className="general-information-container">
      <p className="title">General Information</p>
      <div style={{ display: 'flex' }}>
        {!isEmptyValue(dataCustoms) ? (
          <div className="data-container" style={{ flex: 5 }}>
            <Row>
              {dataCustoms.map((item: any) => {
                return (
                  <Col
                    style={{
                      flexDirection: 'row',
                      display: 'flex',
                      marginTop: 6,
                    }}
                    key={item.field}
                    span={12}
                  >
                    <p className="label">{customFieldName(item)}:</p>
                    <p className="value">{item?.value}</p>
                  </Col>
                )
              })}
            </Row>
          </div>
        ) : (
          <div className="data-container" style={{ flex: 5 }}>
            <Row>
              {leftFields.map((item: any) => {
                return (
                  <Col
                    style={{
                      flexDirection: 'row',
                      display: 'flex',
                      marginTop: 6,
                    }}
                    key={item.field}
                    span={12}
                  >
                    <p className="label">{customFieldName(item)}:</p>
                    <p className="value">{item?.value}</p>
                  </Col>
                )
              })}
            </Row>
          </div>
        )}

        <div className="photo-container">
          <Image src={orderImage()} />
        </div>
      </div>

      {!isEmptyValue(location) && (
        <Col
          style={{
            flexDirection: 'row',
            display: 'flex',
            marginTop: 20,
          }}
        >
          <p className="label">Inspection Location:</p>
          <p className="value" style={{ width: 'unset' }}>
            Lat:{location?.latitude}, Long:{location?.longitude}{' '}
            <p style={{ fontWeight: 400 }}>
              Checked-in on{' '}
              {moment(toJson(get_location_date).get_location_date).format(
                'DD MMM yyyy - hh:mm A'
              )}
            </p>
          </p>
        </Col>
      )}
    </div>
  )
}

export default GeneralInformation
